export function newTxVisitor(readyDriver, id) {
    let allowPending = false;
    return {
        get id() {
            return id;
        },
        allowPending() {
            allowPending = true;
            return this;
        },
        get: () => readyDriver.then(d => d.getTransaction(id, allowPending)),
        getReceipt: () => readyDriver.then(d => d.getReceipt(id))
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHgtdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90eC12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxZQUFZLENBQ3hCLFdBQW1DLEVBQ25DLEVBQVU7SUFFVixJQUFJLFlBQVksR0FBRyxLQUFLLENBQUE7SUFDeEIsT0FBTztRQUNILElBQUksRUFBRTtZQUNGLE9BQU8sRUFBRSxDQUFBO1FBQ2IsQ0FBQztRQUNELFlBQVk7WUFDUixZQUFZLEdBQUcsSUFBSSxDQUFBO1lBQ25CLE9BQU8sSUFBSSxDQUFBO1FBQ2YsQ0FBQztRQUNELEdBQUcsRUFBRSxHQUFHLEVBQUUsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxFQUFFLEVBQUUsWUFBWSxDQUFDLENBQUM7UUFDcEUsVUFBVSxFQUFFLEdBQUcsRUFBRSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0tBQzVELENBQUE7QUFDTCxDQUFDIn0=